import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-more-actions',
  standalone: true,
  templateUrl: './icon-more-actions.component.html',
  styleUrl: './icon-more-actions.component.css'
})
export class IconMoreActionsComponent {
  @Input() size: string = 'size-4';
  @Input() strokeWidth: string = '1.5';
  @Input() className: string = '';
}
